<template>
	<form class="view-venue-search" v-if="visible" v-on:submit.prevent="Handle_OnSubmit">
		<fieldset class="layout-horizontal gap">
			<label>
				<input
					type="text"
					placeholder="Search for venue or location"
					v-bind:value="query"
					v-on:input="Handle_OnInput"
				/>
				<button class="control round size-small type-close" type="button" v-on:click="Handle_OnClickClear">
					Close
				</button>
			</label>
			<button class="size-small" type="submit">Search</button>
		</fieldset>
	</form>
</template>

<script lang="ts">
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';

	/**
	 * Search form component for venue/location searching.
	 *
	 * Provides an input field with clear button and submit functionality.
	 * Emits events for parent components to handle search logic.
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Venue
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewVenueSearch extends ViewBase {
		/**
		 * Current search query value.
		 *
		 * @type string
		 */
		@Prop({ default: '' })
		public query!: string;

		/**
		 * Whether the search form is visible.
		 *
		 * @type boolean
		 */
		@Prop({ default: false })
		public visible!: boolean;

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * Handle clear button click.
		 *
		 * @param PointerEvent e
		 * @return void
		 */
		protected Handle_OnClickClear(e: PointerEvent): void {
			this.$emit('clear', e);
		}

		/**
		 * Handle input value changes.
		 *
		 * @param Event e
		 * @return void
		 */
		protected Handle_OnInput(e: Event): void {
			const target = e.target as HTMLInputElement;
			this.$emit('update:query', target.value);
		}

		/**
		 * Handle form submission.
		 *
		 * @param Event e
		 * @return void
		 */
		protected Handle_OnSubmit(e: Event): void {
			this.$emit('submit', e);
		}

		// endregion: Event Handlers
	}
</script>

<style lang="scss">
	.view-venue-search {
		background: var(--chalky-blue-2);
		border-radius: 0.5rem;
		margin: 1rem -0.25rem;

		fieldset {
			padding: 1rem;
		}

		label {
			flex-grow: 1;
			margin: 0;
			width: auto;
		}
	}
</style>
